<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Workflow assignment</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @submit.prevent="formSubmit">
            <v-container grid-list-xl class="ma-0 pa-0" fluid>
              <v-layout>
                <v-flex xs12 class="subheading grey lighten-3">Organization</v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-select
                    v-bind:items="getAllCompanies"
                    v-model="workflow.company_id"
                    label="Company code"
                    item-value="id"
                    :error-messages="errors.collect('company code')"
                    v-validate="'required'"
                    data-vv-name="company code"
                    required
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >{{ data.item.company_code }} - {{ data.item.description }}</template>
                    <template
                      slot="item"
                      slot-scope="data"
                    >{{ data.item.company_code }} - {{ data.item.description }}</template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md4>
                  <v-select
                    v-bind:items="getAllDivisions"
                    v-model="workflow.division_id"
                    label="Division"
                    item-value="id"
                    :error-messages="errors.collect('division')"
                    item-text="initial"
                    v-validate="'required'"
                    data-vv-name="division"
                    required
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >{{ data.item.initial }} - {{ data.item.description }}</template>
                    <template
                      slot="item"
                      slot-scope="data"
                    >{{ data.item.initial }} - {{ data.item.description }}</template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md4>
                  <v-select
                    v-bind:items="getAllPlants"
                    v-model="workflow.plant_id"
                    label="Plant"
                    item-value="id"
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >{{ data.item.plant }} - {{ data.item.description }}</template>
                    <template
                      slot="item"
                      slot-scope="data"
                    >{{ data.item.plant }} - {{ data.item.description }}</template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md4>
                  <v-select
                    v-bind:items="getAllDepartments"
                    v-model="workflow.department_id"
                    label="Department"
                    item-value="id"
                    :error-messages="errors.collect('department')"
                    v-validate="'required'"
                    data-vv-name="department"
                    required
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >{{ data.item.initial }} - {{ data.item.description }}</template>
                    <template
                      slot="item"
                      slot-scope="data"
                    >{{ data.item.initial }} - {{ data.item.description }}</template>
                  </v-select>
                </v-flex>
                <v-flex xs12 md2 sm3>
                  <v-checkbox label="With contract" v-model="workflow.is_contract"></v-checkbox>
                </v-flex>
                <!-- <v-flex xs12 md3>
                  <v-checkbox label="Oversea procurement" v-model="isOversea"></v-checkbox>
                </v-flex> -->
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-select
                    v-bind:items="workflowType"
                    v-model="workflow.purchaseType"
                    label="Document type"
                    item-value="purchaseType"
                    :error-messages="errors.collect('Document type')"
                    v-validate="'required'"
                    data-vv-name="Document type"
                    required
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >{{ data.item.purchaseType }} - {{ data.item.text }}</template>
                    <template
                      slot="item"
                      slot-scope="data"
                    >{{ data.item.purchaseType }} - {{ data.item.text }}</template>
                  </v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    required
                    label="Requisitioner"
                    v-model="workflow.requisitioner"
                    v-validate="'required|max:12'"
                    :error-messages="errors.collect('requisitioner')"
                    data-vv-name="requisitioner"
                    :counter="12"
                    persistent-hint
                    hint="e.g. SALE-CRT"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 class="subheading grey lighten-3">Max limit &amp; approvers assignment</v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-select
                    v-bind:items="getApprovalLimits.items"
                    v-model="workflow.approval_limit_id"
                    label="Approval limit"
                    item-value="id"
                    :error-messages="errors.collect('approval limit')"
                    v-validate="'required'"
                    data-vv-name="approval limit"
                    required
                  >
                    <template slot="selection" slot-scope="data">{{ data.item.string_value }}</template>
                    <template slot="item" slot-scope="data">{{ data.item.string_value }}</template>
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-combobox
                    :items="getEmployeeID"
                    v-model="workflow.employeeLevel1s"
                    label="Level 1"
                    :error-messages="errors.collect('level 1')"
                    v-validate="'required'"
                    data-vv-name="level 1"
                    required
                    multiple
                  ></v-combobox>
                </v-flex>

                <v-flex xs12 md6>
                  <v-combobox
                    :items="getEmployeeID"
                    v-model="workflow.employeeLevel2s"
                    label="Level 2"
                    clearable
                    multiple
                  ></v-combobox>
                </v-flex>

                <v-flex xs12 md6>
                  <v-combobox
                    :items="getEmployeeID"
                    v-model="workflow.employeeLevel3s"
                    label="Level 3"
                    clearable
                    multiple
                  ></v-combobox>
                </v-flex>

                <v-flex xs12 md6>
                  <v-combobox
                    :items="getEmployeeID"
                    v-model="workflow.employeeLevel4s"
                    label="Level 4"
                    clearable
                    multiple
                  ></v-combobox>
                </v-flex>

                <v-flex xs12 md6>
                  <v-combobox
                    :items="getEmployeeID"
                    v-model="workflow.employeeLevel5s"
                    label="Level 5"
                    clearable
                    multiple
                  ></v-combobox>
                </v-flex>

                <v-flex xs12 md6>
                  <v-combobox
                    :items="getEmployeeID"
                    v-model="workflow.employeeLevel6s"
                    label="Level 6"
                    clearable
                    multiple
                  ></v-combobox>
                </v-flex>

                <v-flex xs12 md6>
                  <v-combobox
                    :items="getEmployeeID"
                    v-model="workflow.employeeLevel7s"
                    label="Level 7"
                    clearable
                    multiple
                  ></v-combobox>
                </v-flex>

                <v-flex xs12 md6>
                  <v-combobox
                    :items="getEmployeeID"
                    v-model="workflow.employeeLevel8s"
                    label="Level 8"
                    clearable
                    multiple
                  ></v-combobox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="onFormWorkflowSubmit"
            dark
            color="accent"
            :loading="getLoading"
            :disable="getLoading"
          >save</v-btn>
          <v-btn to="/workflow">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'change-workflow',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      id: this.$route.params.id,
      workflow: {},
      workflowType: [
        {
          purchaseType: 'PR',
          text: 'Purchase Requisition'
        },
        {
          purchaseType: 'PO',
          text: 'Purchase Order'
        }
      ],
      loader: null,
      snackbar: false,
      timeout: 5000,
      text: '',
      color: '',
      isOversea: false
    }
  },
  computed: {
    ...mapGetters([
      'getLoading',
      'getResponse',
      'getAllCompanies',
      'getAllDivisions',
      'getAllDepartments',
      'getAllPlants',
      'getApprovalLimits',
      'getApprovalUsers',
      'getActiveWorkflow',
      'getEmployeeID'
    ])
  },
  methods: {
    ...mapActions([
      'fetchAllCompanies',
      'fetchAllDivisions',
      'fetchAllDepartments',
      'fetchAllPlants',
      'fetchApprovalLimits',
      'fetchApprovalUsers',
      'setActiveWorkflow',
      'changeWorkflow'
    ]),

    onFormWorkflowSubmit: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          // this.workflow.purchase_org_id = this.isOversea ? 2 : 1
          this.changeWorkflow(this.workflow).then(() => {
            let response = this.getResponse
            this.snackbar = true
            this.text =
              response.status === 200
                ? 'Changed successfully.'
                : response.data.message
            this.color = response.status === 200 ? 'success' : 'error'
          })
        }
      })
    }
  },
  mounted: function () {
    this.fetchAllCompanies()
    this.fetchAllDivisions()
    this.fetchAllDepartments()
    this.fetchAllPlants()
    this.fetchApprovalUsers()
    this.fetchApprovalLimits()
    this.setActiveWorkflow(this.id)
      .then(() => {
        this.workflow = Object.assign({}, this.getActiveWorkflow)
        this.isOversea = this.workflow.purchase_org_id !== 1
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/workflow/ChangeWorkflow.vue